import { useEffect, useState } from 'react';
import api from '../api/client';

// Abbinamenti in Anagrafica da approvare (es. chi si è registrato al portale col CF di una scheda
// importata senza email). Si aggiorna ogni 2 minuti, al ritorno sulla scheda e dopo ogni decisione.
export const avvisaAbbinamentiCambiati = () => window.dispatchEvent(new Event('abbinamenti-cambiati'));

export default function useAbbinamentiDaApprovare(attivo = true) {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!attivo) { setN(0); return; }
    let vivo = true;
    const carica = () => api.get('/anagrafica/abbinamenti/conteggio').then(r => { if (vivo) setN(r.data.da_approvare || 0); }).catch(() => {});
    carica();
    const t = setInterval(carica, 120000);
    const onFocus = () => { if (document.visibilityState === 'visible') carica(); };
    window.addEventListener('abbinamenti-cambiati', carica);
    document.addEventListener('visibilitychange', onFocus);
    return () => { vivo = false; clearInterval(t); window.removeEventListener('abbinamenti-cambiati', carica); document.removeEventListener('visibilitychange', onFocus); };
  }, [attivo]);
  return n;
}
